import { MAX_CLASS_DEPTH } from "@common/constants/class";
import { ClassWithChildren } from "@helpers/class";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

export const DEPTH_LIMIT_TOOLTIP = `Selecting this class would nest beyond the maximum depth of ${MAX_CLASS_DEPTH} levels.`;

/**
 * Build Picker tree items for the class parent-picker from the already
 * normalized class tree. Children keep their existing `order` (the input is
 * pre-sorted, unlike account groups, which sort by name), and a node is
 * disabled as a parent once its `depth` would push a new child past
 * `MAX_CLASS_DEPTH`. A disabled node still renders its existing subtree.
 */
export function buildClassParentTree({
    classesWithChildren,
}: {
    classesWithChildren: ClassWithChildren[];
}): Array<PickerItemData<string>> {
    const buildNode = (
        classNode: ClassWithChildren,
    ): PickerItemData<string> => ({
        value: classNode.id,
        label: classNode.label,
        ...(classNode.depth >= MAX_CLASS_DEPTH - 1 && {
            disabled: true,
            disabledReason: DEPTH_LIMIT_TOOLTIP,
        }),
        ...(classNode.children.length > 0 && {
            children: classNode.children.map(buildNode),
        }),
    });

    return classesWithChildren.map(buildNode);
}
